class SlideCordion {
  container: HTMLElement

  constructor(container: HTMLElement) {
    this.container = container

    if (this.container) {
      this.navigation()
    }
  }

  private navigation() {
    const arrows = this.container.querySelectorAll('.slidecordion__arrow')
    const inputs = this.container.querySelectorAll('.slidecordion__input') as NodeListOf<HTMLInputElement>

    arrows.forEach(arrow =>
      arrow.addEventListener('click', () => {
        const direction = arrow.getAttribute('data-direction')
        const inputsArray = Array.from(inputs)
        const checkkedInputIndex = inputsArray.findIndex(input => input.checked)

        if (direction == 'prev') {
          const input = inputsArray[checkkedInputIndex - 1]
          if (input) input.checked = true
          if (!input) inputsArray[inputsArray.length - 1].checked = true
        }

        if (direction == 'next') {
          const input = inputsArray[checkkedInputIndex + 1]
          if (input) input.checked = true
          if (!input) inputsArray[0].checked = true
        }
      }),
    )
  }
}

export default SlideCordion
